import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '../../util_grid/grid.js';
import './styles/styles.scss';

class BannerResponsive extends Component {
  get title() {
    return this.props.title || null;
  }

  get subtitle() {
    return this.props.subtitle || null;
  }

  get alt() {
    return this.props.alt || '';
  }

  get classes() {
    return this.props.classes || '';
  }

  render() {
    return (
      <div className="banner-responsive">
        <div className="banner-responsive-media">
          <div className="banner-responsive-body container">
            <Row>
              <Col xs={12} className={this.classes}>
                <h1 className="banner-responsive-title">
                  {!!this.title &&
                  <span>{this.title}</span>
                  }
                </h1>
                <div className="banner-responsive-subtitle ">
                  {!!this.subtitle &&
                  <span dangerouslySetInnerHTML={{ __html: this.subtitle }}></span>
                  }
                </div>
              </Col>
            </Row>
            {this.props.image && (
              <div className="banner-resonsive-artwork">
                <img alt={this.alt} src={this.props.image} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}


BannerResponsive.propTypes = {
  /**
   * The title which will be shown in black in the banner
   */
  title: PropTypes.string,
  /**
   * The subtitle which will be shown in green in the banner
   */
  subtitle: PropTypes.string,
  /**
   * Image placed in the background
   */
  image: PropTypes.string,
  /**
   * Image place on the left side of the banner
   */
  imageTablet: PropTypes.string,
  /**
   * Image place on the right side of the banner
   */
  imageMobile: PropTypes.string,
  classes: PropTypes.string,
  alt: PropTypes.string,
};


export default BannerResponsive;
